import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from "react-table";
import request from '../../utils/agent';
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert';
import Loader from 'components/Loader';
import './UserLocations.scss';
import { caStateOpts, usStateOpts } from '../../utils';



export default class UserLocations extends React.Component {
    constructor (props) {
        super(props);
        this.defaultNewLocation = {
            company_name: '',
            website: '',
            phone: '',
            address: '',
            city: '',
            stateprovince: '',
            postal: '',
            display_location: true,
            geospatial: null,
            latitude: null,
            longitude: null,
            country: '',
            showroom: false,
        };

        this.defaultCdataFields = {
            wholesale: true,
            consumer: false,
        };

        this.state = {
            companyId: null,
            searchLoc: '',
            locations: [],
            compLoaded: false,
            newLocation: {...this.defaultNewLocation},
            cdataF: {...this.defaultCdataFields},
            editingLocationId: null,
            savingLocation: false,
            csvUploading: false
        }
    }

    componentDidMount(){
        this.getLocations();
    }

    getLocations = () => {
        request.get('/api/company/locations')
            .then(resp => {
               // console.log(resp.body);
                this.setState({
                    compLoaded: true,
                    companyId: resp.body.company.id,
                    locations: resp.body.company.company_locations
                });
            });

    };

    showAlert(e, row, id) {
        e.preventDefault();
        this.setState({
            deleteId: id,
        });

        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui-dialog'>
                        <h3>Are you sure you want to delete this location?</h3>
                        <br/>
                        <button
                            className="btn btn-default btn-primary btn-view-users cancel"
                            onClick={onClose}>Cancel</button>
                        <button
                            className="btn btn-default btn-primary btn-view-users delete"
                            onClick={() => {
                                this.handleDeleteLocation();
                                onClose();
                            }}>Confirm Delete</button>
                    </div>
                )
            }
        })
    };


    handleDeleteLocation() {
        request.delete(`/api/company/location/${this.state.deleteId}`)
            .then(resp => {
                let locations = this.state.locations.filter(l => l.id !== this.state.deleteId);
                this.setState({
                    locations,
                    deleteId: null
                });
            })
            .catch(err => {
                console.log(err);
            });
    }

    openNewLocationModal = () => {
        document.querySelector('body').classList.add('modal-open');
        this.refs.locationModal.classList.add('in');
    }

    closeNewLocationModal = () => {
        this.refs.locationModal.classList.remove('in');
        document.querySelector('body').classList.remove('modal-open');
        this.setState({
            newLocation: {...this.defaultNewLocation},
            editingLocationId: null,
            savingLocation: false
        });
    }

    saveLocation = async () => {
        // Make sure everything is filled in
        let errors = 0;
        [...this.refs.locationModal.querySelectorAll('[required]')].forEach(input => {
            if(!input.value) {
                input.classList.add('error');
                errors++;
                return;
            }
            input.classList.remove('error');
        });

        if(errors > 0) {
            return;
        }

        this.setState({savingLocation: true});

        let savingLocation = {...this.state.newLocation};

        if(savingLocation.country === 'US') {
            let [err, geo] = await this.getGeocoordinates();
            if(err) {
                if(err.response && err.response.body && err.response.body.addr_status === 'invalid') {
                    alert("Invalid address, please check again");
                }
                savingLocation.geospatial = null;
                savingLocation.latitude = null;
                savingLocation.longitude = null;
            } else {
                savingLocation.geospatial = geo.geospatial;
                savingLocation.latitude = geo.latitude;
                savingLocation.longitude = geo.longitude;
            }

        }

        // Append Dealer ID
        savingLocation.dealer_id = this.state.companyId;

        savingLocation.cdata = `{\\"wholesale\\" ${this.state.cdataF.wholesale} \\"consumer\\" ${this.state.cdataF.consumer}}`;
        //console.log('save loc cdata', savingLocation.cdata);



        // If part of updating, we need to remove the dealer_id
        if(this.state.editingLocationId) {
            delete savingLocation.dealer_id;
        }

        request.post('/api/company/location')
            .send(savingLocation)
            .then(resp => {
                //console.log(resp.body);
                let locations = [...this.state.locations];
                if(!this.state.editingLocationId) {
                    locations.push(resp.body.create_company_location);
                } else {
                    locations = locations.map(l => {
                        if(l.id === resp.body.update_company_location.id) {
                            return resp.body.update_company_location;
                        }
                        return l;
                    })
                }
                this.setState({
                    editingLocationId: null,
                    locations: locations,
                    newLocation: this.defaultNewLocation
                });
                this.closeNewLocationModal();

            })
            .catch(err => {
                console.log(err);
            });
    }

    editLocation = (id) => {
        let editLocation = this.state.locations.filter(l => l.id === id)[0];
        this.setState({
            editingLocationId: id,
            newLocation: {...editLocation}
        }, () => {
            this.openNewLocationModal();
        });
    };

    handleNewLocationInput = (event) => {
        let newLocation = {...this.state.newLocation};
        let value = event.target.value;
        if(event.target.type === 'checkbox') {
            value = event.target.checked;
        }
        newLocation[event.target.name] = value;
        this.setState({newLocation});
    };

    handleCdataInput = (event) => {
        let cdataF = {...this.state.cdataF};
        let value = event.target.checked;
        cdataF[event.target.name] = value;
        this.setState({cdataF});

        //console.log('wholesale', this.state.cdataF.wholesale);
        //console.log('consumer', this.state.cdataF.consumer);
    };

    getGeocoordinates = (address) => {
        if(!address) {
            address = {
                address: this.state.newLocation.address,
                country: this.state.newLocation.country,
                city: this.state.newLocation.city,
                state: this.state.newLocation.stateprovince,
                postal: this.state.newLocation.postal
            }
        }
        return request.post('/api/company/address/coordinates')
            .send({
                address: address
            }).then(resp => {
                return [null, resp.body];
            }).catch(err => {
                return [err];
            })
    };

    newLocationModal = () => {
        let country = '';
        let stateLabel = this.state.newLocation.country === 'CA' ? 'Province *' : 'State *';
        let states = this.state.newLocation.country === 'CA' ? caStateOpts : usStateOpts;
        return (
            <div id="locationModal" ref="locationModal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title"><span id="locationModalTitle"></span>Add Location</h4>
                        </div>
                        <div className="modal-body">
                            <div className="form-group col-xs-12">
                                <label htmlFor="company_name">Company Name</label>
                                <input type="text" id="location_companyname" name="company_name" value={this.state.newLocation.company_name} onChange={this.handleNewLocationInput} className="form-control"/>
                            </div>
                            <div className="form-group col-xs-12">
                                <label htmlFor="website">Website *</label>
                                <input type="text" id="website" name="website" className="form-control" value={this.state.newLocation.website || ''} onChange={this.handleNewLocationInput} required={true}/>
                            </div>
                            <div className="form-group col-xs-12">
                                <label htmlFor="phone">Phone *</label>
                                <input type="text" id="phone" name="phone" className="form-control numeric-phone" value={this.state.newLocation.phone || ''} onChange={this.handleNewLocationInput} required={true} />
                            </div>
                            <div className="form-group col-xs-12">
                                <label htmlFor="country">Country *</label>
                                <select id="country" name="country" className="form-control" value={this.state.newLocation.country} onChange={this.handleNewLocationInput} required={true} >
                                    <option value="">Country *</option>
                                    <option value="US">USA</option>
                                    <option value="CA">Canada</option>
                                </select>
                            </div>
                            <div className="form-group col-xs-12">
                                <div className="address-verify">
                                    <div className="col-xs-4">
                                        <label htmlFor="address">Address *</label>
                                    </div>
                                    <div className="col-xs-8">
                                        <div id="verifiedAddress">
                                            <h5 id="address_verified"></h5>
                                            <h5 id="coordinates_verified"></h5>
                                        </div>
                                    </div>
                                </div>
                                <input type="text" id="address" name="address" className="form-control" value={this.state.newLocation.address} onChange={this.handleNewLocationInput} required={true} />
                            </div>
                            <div className="row">
                                <div className="form-group col-sm-4">
                                    <label htmlFor="city">City *</label>
                                    <input type="text" id="city" name="city" className="form-control" value={this.state.newLocation.city} onChange={this.handleNewLocationInput} required={true} />
                                </div>
                                <div id="us_states" className="form-group col-sm-4">
                                    <label htmlFor="stateprovince">{stateLabel}</label>
                                    <select id="stateprovince" name="stateprovince" className="form-control" value={this.state.newLocation.stateprovince} onChange={this.handleNewLocationInput} required={true} >
                                        {states.map((s, i) => {
                                            return (
                                                <option key={s.id} value={s.id}>{s.display}</option>
                                            )
                                        })}
                                    </select>
                                </div>
                                <div className="form-group col-sm-4">
                                    <label htmlFor="postal">Postal Code *</label>
                                    <input type="text" id="postal" name="postal" className="form-control numeric-zip" value={this.state.newLocation.postal} onChange={this.handleNewLocationInput} required={true} />
                                </div>
                            </div>
                            <div className="form-group col-xs-12">
                                <div className="toggle-switch">
                                    <label htmlFor="display_location" className="toggle-check">
                                        <input type="checkbox" id="display_location" name="display_location" className="toggle-check-input" placeholder="Display Location?" onChange={this.handleNewLocationInput} checked={this.state.newLocation.display_location} />
                                        <span className="toggle-check-text"></span>
                                    </label>
                                    <p>Display Location?</p>
                                </div>
                            </div>
                            <div className="form-group col-xs-12">
                                <div className="toggle-switch">
                                    <label htmlFor="wholesale" className="toggle-check">
                                        <input type="checkbox" id="wholesale" name="wholesale" className="toggle-check-input" placeholder="Wholesale?" onChange={this.handleCdataInput} checked={this.state.cdataF.wholesale} />
                                        <span className="toggle-check-text"></span>
                                    </label>
                                    <p>Wholesale?</p>
                                </div>
                            </div>
                            <div className="form-group col-xs-12">
                                <div className="toggle-switch">
                                    <label htmlFor="consumer" className="toggle-check">
                                        <input type="checkbox" id="consumer" name="consumer" className="toggle-check-input" placeholder="Consumer?" onChange={this.handleCdataInput} checked={this.state.cdataF.consumer} />
                                        <span className="toggle-check-text"></span>
                                    </label>
                                    <p>Consumer?</p>
                                </div>
                            </div>
                            <div className="form-group col-xs-12">
                                <div className="toggle-switch">
                                    <label htmlFor="showroom" className="toggle-check">
                                        <input type="checkbox" id="showroom" name="showroom" className="toggle-check-input" placeholder="Showroom?" onChange={this.handleNewLocationInput} checked={this.state.newLocation.showroom} />
                                        <span className="toggle-check-text"></span>
                                    </label>
                                    <p>Showroom?</p>
                                </div>
                            </div>
                            <button onClick={this.saveLocation} type="button" id="saveLocation" className="btn btn-default btn-primary" name="locationFormSubmit" disabled={this.state.savingLocation}>{this.state.savingLocation ? 'Saving...' : 'Save Location'}</button>
                            <button onClick={this.closeNewLocationModal} type="button" id="cancelLocation" className="btn btn-default btn-primary btn-danger">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    listenerCSVDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
    }

    listenerCSVDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.handleCSVUpload(e.dataTransfer.files);
    }

    handleCSVUpload = (files) => {
        if(!files || files.length === 0) {
            return;
        }
        let reader = new FileReader();
        reader.onload = (el) => {
            let result = el.target.result;
            let lines = result.split('\n'); // Split lines into arrays
            let fields = lines.shift().split(','); // get the fields setup correctly
            let invalidLocations = [];
            let locations = [];
            lines.forEach(line => {
                let values = line.split(',');
                if(values.length === fields.length) {
                    var locObj = {};
                    fields.forEach((key, index) => {
                        if(values[index]) {
                            let k = key.trim();
                            locObj[k] = values[index];
                            if(k == 'display_location') {
                                locObj[k] = values[index] == 1 ? true : false;
                            }
                            if(k == 'showroom') {
                                locObj[k] = values[index] == 1 ? true : false;
                            }
                            if(k == 'wholesale' ) {
                                locObj[k] = values[index] == 1 ? true : false;
                            }
                            if(k == 'consumer') {
                                locObj[k] = values[index] == 1 ? true : false;
                            }

                            locObj['cdata'] = `{\\"wholesale\\" ${locObj['wholesale']} \\"consumer\\" ${locObj['consumer']}}`;
                        }
                    });
                    delete locObj.wholesale;
                    delete locObj.consumer;
                    locations.push(locObj);
                } else {
                    // Trying to create an object that doesn't match
                    invalidLocations.push(line);
                }
            });

            if(locations.length > 0) {
                this.setState({csvUploading: true})
                this.uploadCSVLocations(locations);
            }
            if(invalidLocations.length > 0) {
                let data = encodeURI('data:text/csv;charset=utf-8,' + invalidLocations.join('\n'));
                let link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", "invalid_locations.csv");
                document.body.appendChild(link);
                link.click();
            }
        }
        reader.readAsText(files[0]);
    }

    uploadCSVLocations = async (locations) => {

        let savedLocations = [];
        let failedLocations = [];
        for(let location of locations) {
            let savingLocation = location;

            if(savingLocation.country === 'US') {
                let address = address = {
                    address: savingLocation.address,
                    country: savingLocation.country,
                    city: savingLocation.city,
                    state: savingLocation.stateprovince,
                    postal: savingLocation.postal
                };
                let [err, geo] = await this.getGeocoordinates(address);
                if(err) {
                    if(err.response && err.response.body && err.response.body.addr_status === 'invalid') {
                        failedLocations.push(location);
                    }
                    savingLocation.geospatial = null;
                    savingLocation.latitude = null;
                    savingLocation.longitude = null;
                } else {
                    savingLocation.geospatial = geo.geospatial;
                    savingLocation.latitude = geo.latitude;
                    savingLocation.longitude = geo.longitude;
                }
            }

                // Append Dealer ID
                savingLocation.dealer_id = this.state.companyId;

                await new Promise(resolve => {
                    request.post('/api/company/location')
                        .send(savingLocation)
                        .then(resp => {
                            //console.log(resp.body);
                            savedLocations.push(resp.body.create_company_location);
                            resolve();
                        })
                        .catch(err => {
                            console.log(err);
                            failedLocations.push(location);
                            resolve();
                        });
                });
            }

            this.setState({
                locations: [...this.state.locations, ...savedLocations],
                csvUploading: false
            });

            // Unable to save to these locations
            if (failedLocations.length > 0) {
                let data = encodeURI('data:text/csv;charset=utf-8,' + failedLocations.map(v => v.join(',')).join('\n'));
                let link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", "failed_locations.csv");
                document.body.appendChild(link);
                link.click();
            }
    }

    csvUpload = () => {
        return (
            <div id="csvUploadForm" className="csv-upload" onDragOver={this.listenerCSVDrag} onDrop={this.listenerCSVDrop}>
                <input type="file" name="file" onChange={(e) => this.handleCSVUpload(e.target.files)} id="file" className="csvFile" />
                <label htmlFor="file">
                    <div>
                        <p className="upload-plus">+</p>
                        <p className="upload-add">Add Data</p>
                        <p>Click here or Drag and Drop CSV here</p>
                    </div>
                    {this.state.csvUploading && <Loader /> }
                </label>
            </div>
        )
    }


    render() {

        //console.log('locations', this.state.locations);


        if(!this.state.compLoaded) {
            return <div><h1>Locations</h1><Loader /></div>;
        }
        const columns = [

            {
                Header: 'Id',
                id: 'id',
                accessor: 'id',
                className: 'react--tb--styles',
                show: false
            },
            {
                Header: 'Company Name',
                id: 'company_name',
                accessor: 'company_name',
                className: 'react--tb--styles',
            },
            {
                Header: 'Address',
                id: 'address',
                accessor: loc => <div><div>{loc.address}</div><div>{loc.city}, {loc.stateprovince} {loc.postal}</div></div>,
                className: 'react--tb--styles',
            },
            {
                Header: 'Country',
                id: 'country',
                accessor: 'country',
                className: 'react--tb--styles',
            },
            {
                Header: 'Phone',
                id: 'phone',
                accessor: 'phone',
                className: 'react--tb--styles',
            },
            {
                Header: 'Website',
                id: 'website',
                accessor: 'website',
                className: 'react--tb--styles',
            },
            {
                Header: 'Displayed',
                id: 'displayed',
                accessor: loc => <span className={loc.display_location ? 'approved' : 'declined'}></span>,
                className: 'text-center',
            },
            {
                Header: 'View',
                width: 60,
                Cell:({row, original}) => {
                    return (
                        <button onClick={e => this.editLocation(original.id)} className='view-btn-icon'>
                            <i className='ion-edit'></i>
                        </button>
                    )
                }

            },
            {
                Header: 'Delete',
                className: 'action--tb--styles',
                width: 60,
                Cell: ({row, original}) => {
                    return (
                        <button id="delete" className='delete-btn-icon' onClick={(e) => this.showAlert(e, row, original.id)}>
                            <i className='ion-android-delete'></i>
                        </button>)
                }
            },

        ];
        const pageOpts = [10, 25, 50, 100];

        return(
            <section className='employees--container'>
                <h1>Locations</h1>
                <div className="row toolbar">
                    <button
                        onClick={this.openNewLocationModal}
                        className="btn btn-default btn-primary btn-view-users"> New Location
                    </button>
                    <span>
                        <a href="/sample/sampleAddressUpload.csv">Download</a> sample CSV data
                    </span>
                </div>
                { this.csvUpload() }
                <div>
                    {this.state.locations.length > 0 ?

                        <div className='users-table-hoalder'>
                            <div className='tb-search-holder'>
                                <div className='search--cont'>
                                    Search: <input
                                    className='tb-search-input'
                                    value={this.state.searchLoc}
                                    onChange={e => this.setState({searchLoc: e.target.value})}
                                />
                                </div>
                                <ReactTable
                                    columns={columns}
                                    data={this.state.locations}
                                    pageSizeOptions={pageOpts}
                                    pageSize={this.state.locations.length}

                                />
                            </div>
                        </div> :
                        <ReactTable
                            columns={columns}
                            pageSizeOptions={pageOpts}
                            pageSize={this.state.locations.length}
                        />
                    }
                </div>

                {this.newLocationModal()}

            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/routes/UserLocations/index.js